module.exports = __webpack_public_path__ + "static/media/image2.327f17db.png";